/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PasswordsControllerResetMutationResponse, PasswordsControllerReset400 } from "../../models/passwordsController/PasswordsControllerReset";

function getPasswordsControllerResetUrl() {
  const res = { method: 'POST', url: `/api/v1/passwords/reset` as const }  
  return res
}

/**
 * @description Sets a new password using the token from the reset email link.
 * @summary Reset password using token
 * {@link /api/v1/passwords/reset}
 */
export async function passwordsControllerReset(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PasswordsControllerResetMutationResponse, ResponseErrorConfig<PasswordsControllerReset400>, unknown>({ method : "POST", url : getPasswordsControllerResetUrl().url.toString(), ... requestConfig })  
  return res.data
}